export enum FontSort {
    'Slug Ascending' = 'slug',
    'Slug Descending' = '-slug',
    'Name Ascending' = 'name',
    'Name Descending' = '-name',
    'Release Date Asending' = 'released',
    'Release Date Descending' = '-released',
}
export function isFontSort(value: unknown): value is FontSort {
    return typeof value === 'string' && value in FontSort;
}
